<template>
	<div v-if="is_logged_in"  class="home">
        
		<div class="panel panel-default drop-shadow"  style=" min-height:400px; height:auto; overflow:hidden;">
			<div class="panel-heading panel-grey text-left">
				EMAILS <small v-if="got_user == true"  style='font-weight:normal !important;'>( {{ user.email }} )</small>
			</div>

			<div style="padding:5px;">
				<div id="exTab2">
					<ul class="nav nav-tabs nav-bottom">
						<li>&nbsp;&nbsp;&nbsp;</li>
						<li  v-bind:class="{ active: show_section == 1 }"><a href="#" @click="show_section = 1">Sent ({{ total_sent }})</a></li>
						<li  v-bind:class="{ active: show_section == 2 }"><a href="#" @click="show_section = 2">Received ({{ total_received }})</a></li>
						<li  v-bind:class="{ active: show_section == 3 }"><a href="#" @click="show_section = 3">cc&apos;ed ({{ total_cced }})</a></li>
					</ul>
				</div>
	
				<div class="no-padding">
					<SentEmails    v-show="show_section == 1"></SentEmails>
					<ToEmails      v-show="show_section == 2"></ToEmails>
					<CcEmails      v-show="show_section == 3"></CcEmails>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import EventBus     from '@/event_bus';					// Event Bus
	import SentEmails   from "@/components/emails_sent.vue";
	import ToEmails     from "@/components/emails_to.vue";
	import CcEmails     from "@/components/emails_cc.vue";

    export default {
        components: {
            EventBus,
			SentEmails,
			ToEmails,
			CcEmails,
        },

        data() {
            return {
                got_user      : false,

                show_section  : 1,
                total_sent    : 0,
                total_received: 0,
                total_cced    : 0,
            };
        },

        computed: {
        },
		
		created() {
            EventBus.$on('total_emails_sent', (data) => {
                this.total_sent = data;
            });

            EventBus.$on('total_emails_to', (data) => {
                this.total_received = data;
            });

            EventBus.$on('total_emails_cc', (data) => {
                this.total_cced = data;
            });
        },

        mounted() {
            if (this.is_logged_in()) {
		    	this.get_user_info();
            }
        },
		
        methods: {
			is_logged_in() {
				var status     = false;
				this.api_token = localStorage.getItem('api_token');
				
				if (this.api_token  &&  this.api_token.length == 64) {
					status = true;
				}
					
				return status;
            },
            
            // Get User Info
            get_user_info() {
                this.got_user = false;
                
                const post_data = {
                    api_token:        this.api_token,
                };

                this.axios.post('api/user_info', post_data)
                .then(response => {
                    this.got_user = true;
                    this.user     = response.data;
                })
                .catch(error => {
                    this.$notify({
                        group: 'fs_danger',
                        title: error_msg,
                        text:  error_details,
                        type:  'error'
                    });
                });
            },
        }
    };
</script>
